'use client';

import { Button } from '@venienergygroup/shared-components';
import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { ComponentProps, FC } from 'react';

const BackButton: FC<ComponentProps<typeof Button>> = (props) => {
  const router = useRouter();

  const onClick = () => router.back();

  return (
    <Button
      className="absolute top-12 left-16 rounded-full"
      variant="outline"
      size="icon"
      onClick={onClick}
      {...props}
    >
      <ArrowLeft className="size-4" />
      {props.children}
    </Button>
  );
};

export default BackButton;
